import { render, staticRenderFns } from "./ClassPostCreate.vue?vue&type=template&id=0e7c45f6&scoped=true"
import script from "./ClassPostCreate.vue?vue&type=script&lang=js"
export * from "./ClassPostCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7c45f6",
  null
  
)

export default component.exports